var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "product-teaser product-teaser--big",
      class: _vm.productclass
    },
    [
      _c(
        "a",
        {
          staticClass: "product-teaser__link product-teaser--big__link",
          attrs: { href: _vm.product.link }
        },
        [
          _c(
            "div",
            {
              staticClass: "product-teaser--big__container grid-wrap no-gutter"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "product-teaser--big__right grid-col grid-col-right bp2-col-one-third bp3-col-one-half"
                },
                [
                  _vm.product.show_price
                    ? _c("sale-flash", {
                        attrs: {
                          product: _vm.product,
                          "sale-type": "big-teaser"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.product.image.product
                    ? _c(
                        "div",
                        { staticClass: "product-teaser-big__image-container" },
                        [
                          _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value: _vm.product.image.product,
                                expression: "product.image.product"
                              }
                            ],
                            staticClass: "product-teaser-big__image",
                            attrs: { alt: "" }
                          }),
                          _vm._v(" "),
                          _vm.product.brand.modeo_plus && !_vm.product.sale
                            ? _c(
                                "span",
                                {
                                  staticClass: "modeo-plus",
                                  attrs: { "aria-label": "Modeo+" }
                                },
                                [_vm._v("+")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("product-sticker", {
                            attrs: {
                              id: _vm.product.sticker,
                              "class-name": [
                                "product-sticker",
                                "product-sticker--big"
                              ]
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "product-teaser--big__left grid-col bp2-col-two-thirds bp3-col-one-half"
                },
                [
                  _c("h3", { staticClass: "product-teaser-big__heading" }, [
                    _vm.product.brand.modeo_plus
                      ? _c("span", { staticClass: "modeo-plus" }, [
                          _vm._v(_vm._s(_vm.product.brand.modeo_plus.name))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.product.brand && _vm.product.brand.name
                      ? _c("span", {
                          staticClass: "product-teaser-big__brand",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$sanitize(_vm.product.brand.name)
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._v(
                      "\n          " + _vm._s(_vm.product.name) + "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.product.text
                    ? _c("div", {
                        staticClass: "product-teaser-big__text",
                        domProps: {
                          innerHTML: _vm._s(_vm.$sanitize(_vm.product.text))
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "price price--big",
                      class: { "price--big--no-price": !_vm.product.show_price }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "product-teaser--big__price-amount-container price-amount-container price-amount-container--big"
                        },
                        [
                          _vm.product.price_from_with_add_ons &&
                          _vm.product.show_price
                            ? [
                                _vm.product.variations_has_different_prices
                                  ? _c(
                                      "span",
                                      { staticClass: "starting-from" },
                                      [_vm._v("alk.")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "product-teaser__price-amount price-amount",
                                    class: {
                                      "price-amount--ins":
                                        _vm.product.price_from_with_add_ons !=
                                        _vm.product
                                          .regular_price_from_with_add_ons
                                    }
                                  },
                                  [
                                    _c("price", {
                                      attrs: {
                                        "price-without-tax":
                                          _vm.product.prices_without_tax
                                            .price_from_with_add_ons,
                                        "price-with-tax":
                                          _vm.product.prices_with_tax
                                            .price_from_with_add_ons
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.product.price_from_with_add_ons !=
                                _vm.product.regular_price_from_with_add_ons
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "product-teaser__price-amount price-amount price-amount--del"
                                      },
                                      [
                                        _c("price", {
                                          attrs: {
                                            "price-without-tax":
                                              _vm.product.prices_without_tax
                                                .regular_price_from_with_add_ons,
                                            "price-with-tax":
                                              _vm.product.prices_with_tax
                                                .regular_price_from_with_add_ons
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "price-details price-details--big",
                          class: {
                            "price-details--no-price": !_vm.product.show_price
                          }
                        },
                        [
                          _vm.product.show_price
                            ? _c(
                                "span",
                                {
                                  staticClass: "tax tax--big",
                                  class: {
                                    "tax--highlight tax--highlight-big":
                                      _vm.product.outlet &&
                                      !_vm.$store.getters.showPricesWithVat
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$modeoL10n.vat) +
                                      " " +
                                      _vm._s(_vm.$store.getters.displayVat)
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("button", { staticClass: "btn btn--buy" }, [
                            _vm._v(
                              _vm._s(
                                _vm.product.show_price &&
                                  !_vm.product.disable_buying
                                  ? _vm.$modeoL10n.buy
                                  : _vm.$modeoL10n.check_out
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-506505b9", { render: render, staticRenderFns: staticRenderFns })
  }
}